// components/ui/NavLink.tsx
import { Link as RouterLink, LinkProps as RouterLinkProps } from "react-router-dom";

interface NavLinkProps extends RouterLinkProps {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
}

export function NavLink({ to, children, className, onClick, ...linkProps }: NavLinkProps) {

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (onClick) onClick();
    
    // Pour React Router, on utilise simplement le lien normal
    // Pas besoin de preventDefault() car React Router gère ça automatiquement
    if (linkProps.target === '_blank') {
      e.preventDefault();
      window.open(to.toString(), '_blank');
    }
  };

  return (
    <RouterLink 
      to={to} 
      onClick={handleClick} 
      className={className} 
      {...linkProps}
    >
      {children}
    </RouterLink>
  );
}